import { ACCOUNT_TYPE } from './service';
import { LINK } from './sitemap';

const GA_PLATFORM_SHORT = {
  facebook: 'fb',
  instagram: 'ig',
  threads: 'th',
  youtube: 'yt',
};

const GA_PAGE_PATH = {
  [LINK.HOME]: 'home',
  [LINK.VIEWING]: 'viewing',
  [LINK.MY_VIEWUP]: 'myviewup',
  [LINK.CONTACT]: 'ad',
};

const GA_SHARE_PAGE_PATH = {
  contact: 'ad',
  notice: 'announcement',
};

export const GA_EVENT = {
  KAKAO_INQUIRY: (params: { page: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-kakao-${GA_PAGE_PATH[params.page]}`,
  }),
  LOGIN_SUCCESS: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-login-success`,
  }),

  LOGOUT_SUCCESS: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-logout-success`,
  }),

  MAIN_ANNOUNCEMENT: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-announcement`,
  }),

  MAIN_BANNER: (params: { index: number }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-banner-${params.index + 1}`,
  }),

  MAIN_GUIDE: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-guide-${params.type}`,
  }),

  MAIN_HEADER_NOTIFICATION: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-header-notification`,
  }),

  MAIN_HEADER_VIEWING_MONEY: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-header-viewing-money`,
  }),
  MAIN_LOGIN_CLICK: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-login`,
  }),

  MAIN_SIGNUP: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-signup`,
  }),

  MAIN_VIEWING_CLICK: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-viewing-click`,
  }),

  MAIN_VIEWING_CLICK_AUTO: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-viewing-click-auto`,
  }),

  MAIN_VIEWING_CLICK_POSTING: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-viewing-click-posting`,
  }),

  MAIN_VIEWING_MONEY: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-viewing-money`,
  }),

  MAIN_VIEWING_SETTING_AUTO: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-main-viewing-setting-auto`,
  }),

  MY_VIEWUP_ACCOUNT_ACTIVE: (params: { isActive: boolean }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-${params.isActive ? 'off' : 'on'}`,
  }),

  MY_VIEWUP_ACCOUNT_MENU: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-myviewup-${params.type}`,
  }),

  MY_VIEWUP_ERROR_ACCOUNT_SETTING: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-myviewup-error-account-setting`,
  }),

  MY_VIEWUP_KAKAO_INQUIRY: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-myviewup-kakao`,
  }),

  MY_VIEWUP_SUPPORT: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-myviewup-${params.type}`,
  }),
  MYVIEWUP_ACCOUNT_ADD_ERROR: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-add-error`,
  }),
  MYVIEWUP_ACCOUNT_ADD_NAVER_ERROR: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-add-naver-error`,
  }),

  MYVIEWUP_ACCOUNT_ADD_PLATFORM: (params: { isPlus: boolean; platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-add-${params.isPlus ? 'viewupPlus-' : ''}-${params.platform}`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_ACTIVITY_TOGGLE: (params: { isActivity?: boolean; type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-${params.type === ACCOUNT_TYPE.PLUS ? ACCOUNT_TYPE.VIEWUP_PLUS : ACCOUNT_TYPE.VIEWUP}-active-${params.isActivity ? 'off' : 'on'}`,
  }),

  // 마이뷰업 : 계정관리 & 계정추가
  MYVIEWUP_ACCOUNT_SETTING_ADD: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-add`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_AUTO: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-auto`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_DELETE: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-delete`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_ERROR_FILTER: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-error-filter-${params.type}`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_LOGOUT: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-logout`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_MANAGEMENT: (params: { isPlus?: boolean }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-${params.isPlus ? 'viewupPlus-' : ''}management`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_ORDER_FILTER: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-order-filter`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_PENDING_TAB: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-pending-tab`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_RE_ADD: (params: { isPlus: boolean; platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-${params.isPlus ? 'viewupPlus-' : ''}add-${params.platform}`,
  }),
  MYVIEWUP_ACCOUNT_SETTING_SNS_FILTER: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-account-setting-sns-filter`,
  }),
  NONLOG_VIEWING_CLICK_CAMPAIGN: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-nonlog-viewing-click-campaign`,
  }),
  NONLOG_VIEWING_CLICK_CAMPAIGN_LOGIN_OK: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-nonlog-viewing-click-campaign-ok`,
  }),

  // 비로그인
  NONLOG_VIEWING_MAIN_MENU: (params: { viewingType: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-nonlog-viewing-main-${params.viewingType}`,
  }),

  REFUND_BANK_SETTING: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-refund-bank-setting`,
  }),
  REFUND_BANK_SETTING_ADD: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-refund-bank-setting-add`,
  }),
  REFUND_BANK_SETTING_DELETE: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-refund-bank-setting-delete`,
  }),
  REFUND_HISTORY_CANCEL: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-refund-history-cancel`,
  }),
  REFUND_HISTORY_REASON: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-refund-history-reason`,
  }),
  REFUND_HISTORY_REASON_INQUIRY_KAKAO: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-refund-history-reason-inquiry-kakao`,
  }),
  SEARCH: (params: { pageName: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-${params.pageName}-search`,
  }),

  // 자주묻는 질문, 공지사항, 개선 제안하기, 제휴광고문의
  SHARE: (params: { pageName: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-${GA_SHARE_PAGE_PATH[params.pageName]}-share`,
  }),
  SHARE_PLATFORM: (params: { pageName: string; platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-${GA_SHARE_PAGE_PATH[params.pageName]}-share-${params.platform}`,
  }),

  SIGNUP_SUCCESS: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-signup-success`,
  }),
  SUGGEST_CANCEL: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-reform-cancel`,
  }),
  VIEWING_AUTO_CLICK_ADD_ACCOUNT: (params: { platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-account-add-${GA_PLATFORM_SHORT[params.platform]}`,
  }),
  VIEWING_AUTO_CLICK_APPLY_ALL_ACCOUNT: (params: { platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-apply-all-${GA_PLATFORM_SHORT[params.platform]}`,
  }),
  VIEWING_AUTO_CLICK_CAPTCHA: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-captcha`,
  }),
  VIEWING_AUTO_CLICK_CAPTCHA_REFRESH: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-captcha-refresh`,
  }),

  // 뷰잉하기 : 자동클릭
  VIEWING_AUTO_CLICK_FAIL: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-fail-${params.type}-error`,
  }),
  VIEWING_AUTO_CLICK_MANAGE_ACCOUNT: (params: { platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-account-${GA_PLATFORM_SHORT[params.platform]}`,
  }),
  VIEWING_AUTO_CLICK_NOTE: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-note`,
  }),
  VIEWING_AUTO_CLICK_SET_COUNT: (params: { platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-${GA_PLATFORM_SHORT[params.platform]}`,
  }),
  VIEWING_AUTO_CLICK_SETDONE: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-setdone`,
  }),
  VIEWING_AUTO_CLICK_START: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-start`,
  }),
  VIEWING_AUTO_CLICK_STOP: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-stop`,
  }),
  VIEWING_AUTO_CLICK_SUCCESS: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-success`,
  }),
  VIEWING_AUTO_CLICK_TIME_SET: (params: { max: number; min: number }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-autoclick-timeset-${params.min}_${params.max}`,
  }),
  VIEWING_CLICK_ACCOUNT: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-click-account`,
  }),
  VIEWING_CLICK_ACCOUNT_SET: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-click-account-set`,
  }),
  VIEWING_CLICK_ACCOUNT_SET_DETAIL: (params: { name: string }) => ({
    'gtm.elementClasses': `ga-link-viewing-click-account-set-${params.name}`,
  }),
  VIEWING_CLICK_OPTION: (params: { behavior: string; platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-click-option-${GA_PLATFORM_SHORT[params.platform]}-${params.behavior}`,
  }),
  VIEWING_CLICK_PLATFORM_FILTER: (params: { platform: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-click-${GA_PLATFORM_SHORT[params.platform]}`,
  }),

  // 뷰잉하기 : 클릭형
  VIEWING_CLICK_REFRESH: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-click-refresh`,
  }),

  // 뷰잉하기
  VIEWING_HEADER_MENU: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-header-viewing`,
  }),
  VIEWING_MAIN_MENU: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-main-${params.type}`,
  }),
  VIEWING_MONEY_DATE: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewingmoney-date`,
  }),
  VIEWING_MONEY_FILTER: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewingmoney-filter`,
  }),

  // 뷰잉머니 & 환급신청
  VIEWING_MONEY_HISTORY: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewingmoney-history`,
  }),
  VIEWING_MONEY_MONTH: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewingmoney-month`,
  }),
  VIEWING_MONEY_REFUND: () => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewingmoney-refund`,
  }),

  // 뷰잉하기 : 알아서 뷰잉
  VIEWING_OFF_MENU: (params: { type: string }) => ({
    event: 'gtm.click',
    'gtm.elementClasses': `ga-click-viewing-off-${params.type}`,
  }),
} as const;

export type GaEventNameType = keyof typeof GA_EVENT;
